/*
 * story-atc.js — add-to-cart for story-row buttons and the sticky bar.
 *
 * Anything carrying data-story-atc posts to /cart/add.js and opens the cart
 * drawer (or the cart notification, whichever the theme renders). The href is
 * a real /cart/<variant>:<qty> permalink, so before this file loads, or with
 * JavaScript off, the same button still adds the item and lands on the cart
 * page. Nothing here is required for the button to work, only for it to work
 * without a page load.
 *
 * data-story-atc-remove-line="<line key>" turns the add into a swap: once the
 * add succeeds, that cart line is removed.
 *
 * Triggers sitting outside the product section do not re-render when the
 * variant picker changes, so we listen for variantChange and rewrite their
 * variant id in place.
 */
(function () {
  // Several sections and the cart drawer each load this file, and a second
  // copy would bind a second click listener and add every item twice.
  if (window.__storyAtcLoaded) return;
  window.__storyAtcLoaded = true;

  var SELECTOR = '[data-story-atc]';

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setBusy(trigger, busy) {
    trigger.classList.toggle('story-atc--loading', busy);
    if (busy) {
      trigger.setAttribute('aria-disabled', 'true');
    } else {
      trigger.removeAttribute('aria-disabled');
    }
  }

  function reportError(trigger, message) {
    var target = document.getElementById(trigger.dataset.storyAtcError || '');
    if (target) {
      target.textContent = message;
      target.hidden = false;
      return;
    }
    console.error('[story-atc]', message);
  }

  function addToCart(trigger) {
    var variantId = trigger.dataset.variantId;
    if (!variantId) return;

    var cart = cartElement();
    var quantity = parseInt(trigger.dataset.quantity, 10) || 1;
    var body = { items: [{ id: Number(variantId), quantity: quantity }] };

    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(trigger);
    }

    setBusy(trigger, true);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        // A swap (the cart drawer's upgrade offer) removes the line it replaces,
        // after the add succeeds so a failed add never costs the shopper the item
        // they had. The change response carries the same sections, so it renders.
        var removeLine = trigger.dataset.storyAtcRemoveLine;
        if (!removeLine || response.status) return response;
        var change = { id: removeLine, quantity: 0 };
        if (body.sections) {
          change.sections = body.sections;
          change.sections_url = body.sections_url;
        }
        return fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(change),
        }).then(function (changed) {
          return changed.json();
        });
      })
      .then(function (response) {
        if (response.status) {
          reportError(trigger, response.description || response.message);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'story-atc',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'story-atc',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function (error) {
        // The href is a working cart permalink, so a failed fetch falls back to it
        // rather than leaving the click with nothing to show for it.
        console.error('[story-atc]', error);
        window.location = trigger.getAttribute('href');
      })
      .finally(function () {
        setBusy(trigger, false);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!trigger) return;
    if (trigger.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    addToCart(trigger);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;

      document.querySelectorAll(SELECTOR).forEach(function (trigger) {
        // Only triggers pointed at the product being changed. A button that
        // names a different product keeps the variant it was rendered with.
        if (trigger.dataset.productId && String(trigger.dataset.productId) !== String(variant.product_id)) return;

        trigger.dataset.variantId = variant.id;
        trigger.setAttribute(
          'href',
          window.routes.cart_url + '/' + variant.id + ':' + (parseInt(trigger.dataset.quantity, 10) || 1)
        );
        if (variant.available) {
          delete trigger.dataset.atcUnavailable;
        } else {
          trigger.dataset.atcUnavailable = 'true';
        }
      });
    });
  }
})();
